export default __webpack_public_path__ + "static/media/pv-2.b5f6281e.png";